module.exports = __webpack_public_path__ + "img/BlendBuff-Recast.212a193d.png";